import { DateTime } from 'luxon';
import { useMemo } from 'react';
export var useFinishTime = function (initialTime) {
    return useMemo(function () {
        var finishTime = DateTime.now().plus({ millisecond: initialTime });
        return "".concat(finishTime.toFormat('t').toLowerCase().replace(' ', ''), " ").concat(finishTime.toFormat('ZZZZ'));
    }, [initialTime]);
};
